import { DOCUMENT, inject, Injectable } from '@angular/core';
import { BehaviorSubject, combineLatest, Subject } from 'rxjs';
import { HierarchyMenuService } from '../hierarchy/hierarchy-menu/hierarchy-menu.service';

@Injectable({
  providedIn: 'root',
})
export class MenuService {
  /** If the menu is set to collapsed */
  private readonly menuSetCollapsedSubject$ = new BehaviorSubject<boolean>(false);
  public readonly menuSetCollapsed$ = this.menuSetCollapsedSubject$.asObservable();

  /** If the menu appears collapsed based on menuSetCollapsed$ and hierarchyCollapsed$ */
  private readonly menuCollapsedSubject$ = new BehaviorSubject<boolean>(false);
  public readonly menuCollapsed$ = this.menuCollapsedSubject$.asObservable();

  /** If the hierarchy menu is set to collapsed */
  private readonly hierarchyCollapsedSubject$ = new BehaviorSubject<boolean>(true);
  public readonly hierarchyCollapsed$ = this.hierarchyCollapsedSubject$.asObservable();

  /** Toggle offcanvas overlay on and off */
  private readonly offcanvasSubject$ = new Subject<void>();
  public readonly offcanvas$ = this.offcanvasSubject$.asObservable();

  private isMobile!: boolean;
  private window = inject(DOCUMENT).defaultView as Window;
  private readonly mobileBreakpoint = 768; // md breakpoint of Bootstrap

  constructor() {
    this.window.onresize = (): boolean => this.updateMobileStatus();
    this.updateMobileStatus();

    combineLatest([this.menuSetCollapsed$, this.hierarchyCollapsed$, inject(HierarchyMenuService).enabled$]).subscribe(
      ([menuCollapsed, hierarchyCollapsed, hierarchyEnabled]) =>
        this.menuCollapsedSubject$.next(menuCollapsed || (hierarchyEnabled && !hierarchyCollapsed)),
    );
  }

  public toggleMenuCollapsed(): void {
    if (this.isMobile) {
      this.offcanvasSubject$.next();
    } else {
      this.menuSetCollapsedSubject$.next(!this.menuCollapsedSubject$.value);
      if (!this.hierarchyCollapsedSubject$.value) {
        this.hierarchyCollapsedSubject$.next(true);
      }
    }
  }

  public toggleHierarchyCollapsed(): void {
    this.hierarchyCollapsedSubject$.next(!this.hierarchyCollapsedSubject$.value);
  }

  private updateMobileStatus(): boolean {
    return (this.isMobile = this.window.innerWidth <= this.mobileBreakpoint);
  }
}
